/* eslint-disable react/no-unescaped-entities */
import React from 'react';

function Release20250619() {
  return (
    <section className="flex flex-col gap-4 border-b">
      <h2 className="font-gothammedium text-neutral-700">Enrichment_25/S09</h2>
      <p className="-mt-4">19th June 2025</p>

      <h4>Notice:</h4>
      <h5>Releases Covered:</h5>
      <ul className="-mt-4">
        <li>Enrichment_25/S09</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        New Functionality
      </h3>

      {/* <h4>User Management</h4> */}

      <ul className="-mt-4">
        <li>(Indexing) - Speed improvements</li>
        <li>Completion % on PLP refreshing on update outside of the PDP</li>
        <li>Pending user Notifications</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">
        Attributes Definition
      </h3>

      {/* <h4>User Management</h4> */}

      <ul className="-mt-4">
        <li>New overhauled and improved UI</li>
        <ul className="-mt-4">
          <li>Show Product count for each facia</li>
          <li>Logs Redesign</li>
          <li>Search Filters Redesign</li>
        </ul>
        <li>Faster and more stable build</li>
      </ul>

      <h3 className="font-gothammedium text-neutral-700">Fixes & Improvements</h3>

      <ul className="-mt-4">
        <li>Prism Unit testing</li>
        <ul className="-mt-4">
          <li>Dashboard</li>
          <li>User Management</li>
        </ul>
        <li>Tax Rate & Tax Code parity between Export and DB</li>
        <li>Prism not updating when changing categories and attributes</li>
      </ul>
    </section>
  );
}

export default Release20250619;
